<template>
  <el-dialog
      :visible="visible"
      @close="$emit('close')"
      width="520px"
      title="筛选"
      custom-class="theme-dialog search-vote"
  >
    <div>
      <div v-for="item in list" :key="item.q_id" class="mb-4 last:mb-0">
        <vote-search :question="item" />
      </div>
    </div>
    <template v-slot:footer>
      <div>
        <el-button type="primary" @click="onConfirm">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import VoteSearch from '@/vote/search/VoteSearch.vue'

export default {
  name: 'SearchVotePopup',
  components: { VoteSearch },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirm', this.list)
    }
  },
  mounted() {
    this.visible = true
  }
}
</script>

<style scoped lang="scss">
.search-vote {
  color: #000;
  line-height: 22px;
}
</style>